/**
 * The reports constants module houses reports-specific configurations.
 *
 * @module routes.reports.constants
 */

angular.module('routes.reports.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var reports;

      // Set defaults.
      reports = {};

      /**
       * Defines reports constants.
       *
       * @attribute REPORTS
       * @type String
       * @readOnly
       */
      $provide.constant('REPORTS', reports);
    }
  ]);
